import React, { Fragment, useContext } from 'react';
import { Redirect } from 'react-router-dom';

import { AuthContext } from '../../context/authContext';

import AuthHeader from '../../container/Layout/AuthHeader';
import AuthFooter from '../../container/Layout/AuthFooter';

const SignupSuccess = () => {
  document.title = 'CrowdFarmer | Registration Success';

  const { user } = useContext(AuthContext);

  if (!user) {
    return <Redirect to="/unauthorized" />;
  }

  return (
    <Fragment>
      <AuthHeader />
      <div className="Container mx-auto">
        <div className="container-inner mx-auto">
          <div className="flex items-center justify-center h-screen">
            <div className="text-center">
              <h3 className="text-cf-dark">Registration successfully!</h3>
              <p className="text-xl mb-5 text-gray-700">
                Your account has been created successfully.
                <br />
                Next step is to verify your email.
                <br />
                Check your email (spam/junk) for an email from us and click on the "Confirm Email"
                button!
              </p>
            </div>
          </div>
        </div>
      </div>
      <AuthFooter />
    </Fragment>
  );
};

export default SignupSuccess;
